<i18n>
{
  "en": {
    "title": "About the Schneider Sustainability Report",
    "description": "The Schneider Sustainability Report engages stakeholders as critical participants in ongoing conversation about energy efficiency. Learn about our achievements and goals as they relate to current business strategy and ongoing commitment to sustainable development.",
    "introduction": {
      "section": "Looking Ahead",
      "title": "",
      "about": {
        "hero": {
          "section": "Looking Ahead",
          "title": "About This Report"
        },
        "aboutReport": {
          "title": "About this report",
          "para": "This report is intended to actively engage stakeholders as critical participants in ongoing conversation about energy efficiency. You will find an overview of Schneider Electric achievements and goals as they relate to current business strategy and ongoing commitment to sustainable development. Our goal is to provide transparent, comprehensive, and succinct information about Schneider Electric, incorporating the concerns of all internal and external stakeholders. Four international frameworks for corporate social responsibility (CSR) reporting information; the Global Reporting Initiative (GRI); the United Nations Global Compact; the Integrated Reporting; and the ISO 26000."
        },
        "acknowledgements": {
          "title": "Acknowledgements",
          "stakeHolders": {
            "title": "Our customers and external stakeholders:",
            "para": "Ashoka, China National Building Material Group, Marriott<sup>&reg;</sup>, Microsoft<sup>&reg;</sup>, South Australia Power Networks, Telefónica, Vernon Turner/IDC, Waterforce, Alice Audouin at Art of Change 21, Craig Blackburn at Blackhills Farm, Scott Bosarge at AEG, Fran Muña at Telefónica, Christian Noce and Andrea Valcalda at ENEL, Satya Nadella at Microsoft<sup>&reg;</sup>, and Michael Wang at Marriott<sup>&reg;</sup> International."
          },
          "agenciesPartners": {
            "title": "Agencies, partners:",
            "para": "Schneider Electric Global Marketing, NAM and EMEA Creative Studios, and Column Five for providing the design, development, and project management of this report."
          },
          "photoCredit": {
            "title": "Photo credit:",
            "para": "Agence VU, Stéphanie Lacombe, Yvan Brien Photographies, Gautier Demouveaux/ASO, Getty Images<sup>&reg;</sup>, and Photothèque Schneider Electric."
          },
          "schneiderTeams": {
            "title": "All Schneider Electric teams who contributed to the report:",
            "para": "Schneider Electric Board of Directors, Executive Committee Members, Schneider Electric Global Marketing, Brand Marketing Engagement, Thomas André, Patricia Benchenna, Pauline Colnot, Philippe Delorme, Gilles Vermot Desroches, Jamie Ellis, Venancio Figueroa, Delphine Gieux, Maxime Goualin, Xavier Houot, Erin Kalidindi, Morgane Lasserre, Yeonjoo Lee, Chris Leong, Emilienne Lepoutre, Lauren Mahoney-Pick, Miriana Matei, Veronique Moine, Denise Molina, Raj Munusamy, Tina Mylon, Cyril Perducat, Vincent Petit, Amandine Petitdemange, Kellie Tabor-Hann, Steve Wilhite, Leslie Zambelli, and more.",
            "paraB": "The Registration Document filed with France’s Autorité des Marchés Financiers (AMF) is available by request on the Finance page of our corporate website: www.schneider-electric.com/company."
          }
        },
        "rightsReserved": "©2018 Schneider Electric. All Rights Reserved. Schneider Electric | Life Is On, EcoStruxure, ecoDesign Way, Green Premium, ecoLabel, StruxureOn, Masterpact, Altivar, Modicon, Easergy, Wonderware, ecoFit, Conext, and Energy University are trademarks and the property of Schneider Electric SE, its subsidiaries, and affiliated companies. Microsoft is a registered trademark of Microsoft Corporation in the United States and/or other countries. All other trademarks are the property of their respective owners. LinkedIn, the LinkedIn logo, the IN logo, and InMail are registered trademarks or trademarks sof LinkedIn Corporation and its affiliates in the United States and/or other countries.",
        "references": {
          "referenceA": "<sup>1</sup> IEA, World Energy Outlook 2016",
          "referenceB": "<sup>2</sup> IHS, March 2016",
          "referenceC": "<sup>3</sup> Increase of global energy consumption 2014 – 2040 in New Policy Scenario extrapolated to 2050. IEA, World Energy Outlook 2016",
          "referenceD": "<sup>4</sup> <a class='t-grey' href='https://www.iea.org/publications/freepublications/publication/weo-2017-special-report-energy-access-outlook.html' target='_blank'>International Energy Agency, Energy Access Outlook 2017 https://www.iea.org/publications/freepublications/publication/weo-2017-special-report-energy-access-outlook.html</a>",
          "referenceE": "<sup>5</sup>  <a class='t-grey' href='http://www.independent.co.uk/environment/solar-and-wind-power-cheaper-than-fossil-fuels-for-the-first-time-a7509251.html' target='_blank'>http://www.independent.co.uk/environment/solar-and-wind-power-cheaper-than-fossil-fuels-for-the-first-time-a7509251.html</a>"
        }
      }
    }
  },
  "fr": {
    "title": "À propos de ce rapport",
    "description": "The Schneider Sustainability Report engages stakeholders as critical participants in ongoing conversation about energy efficiency. Learn about our achievements and goals as they relate to current business strategy and ongoing commitment to sustainable development.",
    "introduction": {
      "section": "Anticiper demain",
      "title": "",
      "about": {
        "hero": {
          "section": "Anticiper demain",
          "title": "À propos de ce rapport"
        },
        "aboutReport": {
          "title": "À propos de ce rapport",
          "para": "A propos de ce rapport vise à engager un dialogue avec toutes nos parties prenantes. Vous y trouverez un aperçu des objectifs et résultats de l’année écoulée en matière de stratégie de développement durable. Notre but est d’instaurer un dialogue transparent, exhaustif et précis sur notre entreprise, incluant la voix de nos parties prenantes internes et externes. Nous nous appuyons sur quatre standards en matière de reporting et information que sont le Global Reporting Initiative (GRI), le Pacte mondial des Nations unies, l’Integrated Reporting, et la norme ISO 26000. Ce rapport est disponible en français et en anglais, et accessible en version numérique sur : <a href='http://sdreport.schneider-electric.com'>sdreport.schneider-electric.com</a>"
        },
        "acknowledgements": {
          "title": "Remerciements",
          "stakeHolders": {
            "title": "Nos clients et parties prenantes externes :",
            "para": "Ashoka, China National Building Material Group, Marriott<sup>&reg;</sup>, Microsoft<sup>&reg;</sup>, South Australia Power Networks, Telefónica, Vernon Turner/IDC, Waterforce, Alice Audouin at Art of Change 21, Craig Blackburn at Blackhills Farm, Scott Bosarge at AEG, Fran Muña at Telefónica, Christian Noce and Andrea Valcalda at ENEL, Satya Nadella at Microsoft<sup>&reg;</sup>, and Michael Wang at Marriott<sup>&reg;</sup> International."
          },
          "agenciesPartners": {
            "title": "Agences, partenaires :",
            "para": "Le département Communication du service Marketing Global de Schneider Electric a assuré la rédaction, la conception et le suivi du projet. La production a été conduite par l’agence Column Five."
          },
          "photoCredit": {
            "title": "Crédits photos :",
            "para": "Agence VU, Stéphanie Lacombe, Yvan Brien Photographies, Gautier Demouveaux/ASO, Getty Images<sup>&reg;</sup>, Cécile Liénaux, photothèque Schneider Electric. "
          },
          "schneiderTeams": {
            "title": "Toutes les équipes de Schneider Electric ayant participé à l’élaboration de ce rapport :",
            "para": "Le Conseil d’administration de Schneider Electric, les membres du Comité exécutif, le Comité consultatif des Femmes de Schneider Electric,Cyril Perducat, Kelly Tabor -Hann, Nisa Bradly, Steve Thomas André, Brigitte Antoine, Patricia Benchenna, Anthime Caprioli, Delphine Gieux, Carole Jacqz, Venancio Figueroa, Esther Finidori, Maxime Goualin, Alcyon Grandizo, Xavier Houot, Aurélie Jardin, Anurag Kapoor, Diane Le Goff, Emilienne Lepoutre, François Milioni, Morgane Peloille, Amandine Petitdemange, Vincent Petit, Christophe Poline, Aurélie Richard, Véronique Roquet-Montegon, Abhimanyu Sahu, DK Singh, Tina Mylon, Annette Pau, Denise Molina, Agata Gronek ,Jose Pereira, Devinder  Kishore, Gilles Vermot Desroches, Leslie Zambelli, and more.",
            "paraB": "Le Document de Référence déposé auprès de l’Autorité des Marchés Financiers (AMF) est disponible sur simple demande à la page Finance de notre site Internet :  www.schneider-electric.com/company."
          }
        },
        "rightsReserved": "©2018 Schneider Electric | Life Is On, EcoStruxure, ecoDesign Way, Green Premium, ecoLabel, StruxureOn, Masterpact, ecoFit, Conext et Energy University sont des marques détenues par Schneider Electric Industries SAS ou ses filiales. Tous droits réservés. Schneider Electric | Life Is On, EcoStruxure, ecoDesign Way, Green Premium, ecoLabel, StruxureOn, Masterpact, ecoFit, Conext et Energy University sont des marques détenues par Schneider Electric Industries SAS ou ses filiales. Microsoft® est une marque déposée de Microsoft Corporation aux États-Unis et dans d'autres pays.  Toutes les autres marques appartiennent à leurs propriétaires respectifs.  LinkedIn, les logos LinkedIn et IN, et InMail sont des marques déposées de LinkedIn Corporation et de ses filiales aux États-Unis et/ou dans d'autres pays.",
        "references": {
          "referenceA": "<sup>1</sup> IEA, World Energy Outlook 2016",
          "referenceB": "<sup>2</sup> IHS, March 2016",
          "referenceC": "<sup>3</sup> Augmentation de la consommation globale d'énergie entre 2014 et 2040 selon le scénario « Nouvelles politiques » extrapolé jusqu’en 2050. World Energy Outlook 2016, AIE",
          "referenceD": "<sup>4</sup> <a class='t-grey' href='https://www.iea.org/publications/freepublications/publication/weo-2017-special-report-energy-access-outlook.html' target='_blank'>Agence internationale de l’énergie, Energy Access Outlook 2017 https://www.iea.org/publications/freepublications/publication/weo-2017-special-report-energy-access-outlook.html</a>",
          "referenceE": "<sup>5</sup>  <a class='t-grey' href='http://www.independent.co.uk/environment/solar-and-wind-power-cheaper-than-fossil-fuels-for-the-first-time-a7509251.html' target='_blank'>http://www.independent.co.uk/environment/solar-and-wind-power-cheaper-than-fossil-fuels-for-the-first-time-a7509251.html</a>"
        }
      }
    }
  }
}
</i18n>

<template>
  <div id="">
    <Hero :loResSrc="require('@/assets/img/introduction/about-this-report-hero-low.jpg')" :hiResSrc="require('@/assets/img/introduction/about-this-report-hero.jpg')" chapter="07" :section="$t('introduction.about.hero.section')" :title="$t('introduction.about.hero.title')" :grayBG="true" />

    <section class="m-b-120 l-section-pad l-bg-white">
      <Txt>
      <!-- <h1 v-html="$t('introduction.about.aboutReport.title')"/> -->
      <p v-html="$t('introduction.about.aboutReport.para')"/>
      </Txt>
    </section>

    <section class="m-b-120 m-t-120">
      <Txt>
        <h2 id="acknowledgements" v-html="$t('introduction.about.acknowledgements.title')"/>

        <h3 v-html="$t('introduction.about.acknowledgements.stakeHolders.title')"/>
        <p v-html="$t('introduction.about.acknowledgements.stakeHolders.para')"/>

        <h3 v-html="$t('introduction.about.acknowledgements.agenciesPartners.title')"/>
        <p v-html="$t('introduction.about.acknowledgements.agenciesPartners.para')"/>

        <h3 v-html="$t('introduction.about.acknowledgements.photoCredit.title')"/>
        <p v-html="$t('introduction.about.acknowledgements.photoCredit.para')"/>

        <h3 v-html="$t('introduction.about.acknowledgements.schneiderTeams.title')"/>
        <p v-html="$t('introduction.about.acknowledgements.schneiderTeams.para')"/>
        <p v-html="$t('introduction.about.acknowledgements.schneiderTeams.paraB')"/>

        <p v-html="$t('introduction.about.rightsReserved')"/>
      </Txt>
    </section>

    <hr>

    <References class="m-b-30">
      <Reference v-html="$t('introduction.about.references.referenceA')"/>
      <Reference v-html="$t('introduction.about.references.referenceB')"/>
      <Reference v-html="$t('introduction.about.references.referenceC')"/>
      <Reference v-html="$t('introduction.about.references.referenceD')"/>
      <Reference v-html="$t('introduction.about.references.referenceE')"/>
    </References>

    <FooterNav
      prevRoute="LookingAhead_SustainabilityApproach" />

  </div>
</template>

<script>
import FooterNav from '@/components/FooterNav'
import Txt from '@/components/Txt'
import References from '@/components/References'
import Reference from '@/components/Reference'
import Hero from '@/components/Hero'

export default {
  name: 'LookingAhead_About',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    FooterNav,
    Txt,
    References,
    Reference,
    Hero
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/looking-ahead/about.vue